(function () {
  'use strict';

  function emitConversion(root, action, extra) {
    var detail = Object.assign({
      action: action,
      offer: root.getAttribute('data-offer') || '',
      page: window.location.pathname
    }, extra || {});

    window.dispatchEvent(new CustomEvent('rlp_promo_conversion', { detail: detail }));

    // Tracking placeholder: if GTM/dataLayer is installed later, these events are ready to use.
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: 'rlp_promo_conversion' }, detail));
    }
  }

  function fillAttribution(root) {
    var params = new URLSearchParams(window.location.search);
    var pairs = {
      'utm_source': params.get('utm_source') || '',
      'utm_medium': params.get('utm_medium') || '',
      'utm_campaign': params.get('utm_campaign') || '',
      'utm_term': params.get('utm_term') || '',
      'utm_content': params.get('utm_content') || '',
      'landing_page': window.location.href
    };

    Object.keys(pairs).forEach(function (key) {
      var field = root.querySelector('[data-attribution="' + key + '"]');
      if (field) field.value = pairs[key];
    });
  }

  function setDateMinimum(root) {
    var field = root.querySelector('input[type="date"][data-preferred-date]');
    if (!field) return;
    var now = new Date();
    var yyyy = now.getFullYear();
    var mm = String(now.getMonth() + 1).padStart(2, '0');
    var dd = String(now.getDate()).padStart(2, '0');
    field.min = yyyy + '-' + mm + '-' + dd;
  }

  function applyExpiry(root) {
    var displayDate = root.getAttribute('data-deadline-date');
    if (!displayDate) return;
    var match = displayDate.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (!match) return;

    // Promotion remains valid through the end of the displayed Darwin/ACST date.
    var iso = match[3] + '-' + String(match[2]).padStart(2, '0') + '-' + String(match[1]).padStart(2, '0') + 'T23:59:59+09:30';
    var cutoff = new Date(iso);
    if (Number.isNaN(cutoff.getTime())) return;
    if (new Date() > cutoff) root.setAttribute('data-expired', 'true');
  }

  function init(root) {
    if (root.dataset.rlpPromoReady === 'true') return;
    root.dataset.rlpPromoReady = 'true';

    fillAttribution(root);
    setDateMinimum(root);
    applyExpiry(root);

    root.querySelectorAll('[data-track-action]').forEach(function (element) {
      element.addEventListener('click', function () {
        emitConversion(root, element.getAttribute('data-track-action'));
      });
    });

    var form = root.querySelector('form.rlp-promo__form');
    if (form) {
      form.addEventListener('submit', function () {
        emitConversion(root, 'booking_form_submit');
      });
    }

    var success = root.querySelector('[data-form-success]');
    if (success) {
      emitConversion(root, 'booking_form_success');
      setTimeout(function () {
        success.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 120);
    }
  }

  function boot() {
    document.querySelectorAll('.rlp-promo').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();
